/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardIssuesCount
 */
export interface DashboardIssuesCount {
    /**
     * 
     * @type {string}
     * @memberof DashboardIssuesCount
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardIssuesCount
     */
    count: number;
}

/**
 * Check if a given object implements the DashboardIssuesCount interface.
 */
export function instanceOfDashboardIssuesCount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function DashboardIssuesCountFromJSON(json: any): DashboardIssuesCount {
    return DashboardIssuesCountFromJSONTyped(json, false);
}

export function DashboardIssuesCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardIssuesCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'count': json['count'],
    };
}

export function DashboardIssuesCountToJSON(value?: DashboardIssuesCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'count': value.count,
    };
}

